import { GET_MF_ORDER_BOOK, } from "../../interface/orderBook";
const initState = {
    data: {
        ordLst: [],
        cutoffDt: "",
        cutoffTm: "",
    },
};
const MFOrderBookReducer = (state = initState, action) => {
    try {
        switch (action.type) {
            case GET_MF_ORDER_BOOK:
                return Object.assign(Object.assign({}, state), { data: action.payload.data });
            default:
                return Object.assign({}, state);
        }
    }
    catch (error) {
        console.log(error);
    }
};
export default MFOrderBookReducer;
